import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

import { ref, computed, onMounted } from "vue";

import Paginator from "primevue/paginator";
import ListItemsWithTableLayout from "@/widgets/layouts/ListItemsWithTableLayout.vue";
import TopListAdsCabinetsPanel from "@/entities/dictionaries/ads_cabinets/panels/TopListAdsCabinetsPanel.vue";
import EmptyTableMessage from "@/entities/segments/EmptyTableMessage.vue";
import HandlerAccessDenied from "@/shared/base/HandlerAccessDenied.vue";
import AdsCabinetsTable from "@/entities/dictionaries/ads_cabinets/AdsCabinetsTable.vue";
import AdsCabinetFilterForm from "@/entities/dictionaries/ads_cabinets/forms/AdsCabinetFilterForm.vue";

import {
  useAdsCabinetsStore,
  AdsCabinetsParams,
} from "@/store/dictionaries/ads_cabinets";
import { useAuthStore } from "@/store/auth/login";
import { rowsCount } from "@/services/utils/Pagination";
import { setAdsCabinetsParamsByFilter } from "@/services/dictionaries/ads_cabinets";
import { FilterForm } from "@/services/dictionaries/ads_cabinets";


export default /*#__PURE__*/_defineComponent({
  __name: 'AdsCabinetsPage',
  setup(__props) {

const store = useAdsCabinetsStore();
const authStore = useAuthStore();
const isLoading = ref(false);
const isFilterEnabled = ref(false);
const isFilterSetted = ref(false);
const tableDisplaySettings = ref({
  first: 0,
  orderField: "",
  commonFilter: "",
  filter: {} as FilterForm,
});

const isDenied = computed(() => {
  return authStore.isDeniedForPermissions(
    ["system:read", "system:edit"],
    ["dictionaries:read", "dictionaries:edit"]
  );
});

const filteredAdsCabinets = computed(() => {
  return store.adsCabinetsList;
});

const activeFirstFromStore = computed(() => store.activeFirst);

onMounted(() => {
  loadData();
});

const loadData = () => {
  isLoading.value = true;
  updateAdsCabinetsList();
};

const setCommonFilter = (filter: string) => {
  tableDisplaySettings.value.commonFilter = filter;
  updateAdsCabinetsList();
};

const sortTable = (order_by: string) => {
  tableDisplaySettings.value.orderField = order_by;
  updateAdsCabinetsList();
};

const setFilter = (filter: FilterForm, isSetted: boolean) => {
  tableDisplaySettings.value.filter = filter;
  isFilterSetted.value = isSetted;
  updateAdsCabinetsList();
};

const updateAdsCabinetsList = () => {
  let isEnded = false;
  setTimeout(() => {
    if (!isEnded) {
      isLoading.value = true;
    }
  }, 200);
  const params: AdsCabinetsParams = {
    page: tableDisplaySettings.value.first + 1,
    per_page: rowsCount(43),
  };

  setAdsCabinetsParamsByFilter(params, tableDisplaySettings.value);

  store.getAdsCabinets(params).finally(() => {
    isLoading.value = false;
    isEnded = true;
  });
};

let resizeTimeout: number;

window.addEventListener("resize", function () {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(updateAdsCabinetsList, 200);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ListItemsWithTableLayout, null, {
    body: _withCtx(() => [
      _createVNode(HandlerAccessDenied, { "is-denied": isDenied.value }, {
        default: _withCtx(() => [
          _createVNode(AdsCabinetFilterForm, {
            isFilterEnabled: isFilterEnabled.value,
            onToggleFilter: _cache[0] || (_cache[0] = ($event: any) => (isFilterEnabled.value = !isFilterEnabled.value)),
            onSetFilter: setFilter
          }, null, 8, ["isFilterEnabled"]),
          _createVNode(TopListAdsCabinetsPanel, {
            onSetCommonFilter: setCommonFilter,
            onToggleFilter: _cache[1] || (_cache[1] = ($event: any) => (isFilterEnabled.value = !isFilterEnabled.value)),
            isFilterEnabled: isFilterEnabled.value,
            isFilterSetted: isFilterSetted.value
          }, null, 8, ["isFilterEnabled", "isFilterSetted"]),
          _createElementVNode("div", {
            id: "table-container",
            class: _normalizeClass(["table-container flex flex-col", [
            filteredAdsCabinets.value && filteredAdsCabinets.value.length == 0
              ? 'empty'
              : 'filled',
          ]])
          }, [
            _createVNode(AdsCabinetsTable, {
              "ads-cabinets": filteredAdsCabinets.value,
              isActiveFirst: activeFirstFromStore.value,
              isLoading: isLoading.value,
              rowsCount: _unref(rowsCount)(43) * tableDisplaySettings.value.first,
              onSortTable: sortTable,
              onUpdateTable: updateAdsCabinetsList
            }, null, 8, ["ads-cabinets", "isActiveFirst", "isLoading", "rowsCount"]),
            (
              filteredAdsCabinets.value &&
              filteredAdsCabinets.value.length == 0 &&
              !isLoading.value
            )
              ? (_openBlock(), _createBlock(EmptyTableMessage, { key: 0 }, {
                  text: _withCtx(() => [
                    _createTextVNode(" Примените другой фильтр или создайте первый кабинет. "),
                    _hoisted_1,
                    _createTextVNode(" Для этого кликните на кнопку \"Создать рекламный кабинет\". ")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ], 2),
          _createVNode(_unref(Paginator), {
            first: tableDisplaySettings.value.first,
            "onUpdate:first": [
              _cache[2] || (_cache[2] = ($event: any) => ((tableDisplaySettings.value.first) = $event)),
              updateAdsCabinetsList
            ],
            rows: 1,
            class: "s-paginator",
            totalRecords: _unref(store).adsCabinetsPagesCount,
            template: "PrevPageLink CurrentPageReport NextPageLink",
            currentPageReportTemplate: "{first} из {totalRecords}"
          }, null, 8, ["first", "totalRecords"])
        ]),
        _: 1
      }, 8, ["is-denied"])
    ]),
    _: 1
  }))
}
}

})